export { default } from './PromoterHeaderByType';